import React, { useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';
import LoadingScreen from './components/LoadingScreen';
import Admin from './pages/Admin';
import SecretAdmin from './pages/SecretAdmin';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <FeaturesSection />
      <Footer />
    </div>
  );
};

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const isHome = typeof window !== 'undefined' && window.location.pathname === '/';

  return (
    <>
      {isHome && isLoading && <LoadingScreen onLoadingComplete={() => setIsLoading(false)} />}
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/:token" element={<SecretAdmin />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
